/**
 * @module app.config.stateservice
 */
class ConfigStateService {
  /**
   * @param {!app.config.apiservice} appConfigApiService
   * @ngInject
   */
  constructor(appConfigApiService) {
    /**
     * @private
     */
    this.configApiService_ = appConfigApiService;

    /**
     * @type {appx.UserSettings}
     */
    this.userSettings;

    /**
     * @private
     * @type {angular.$q.Promise<appx.UserSettings>}
     */
    this.userSettingsPromise_;
  }

  /**
   * @return {!angular.$q.Promise<appx.UserSettings>}
   */
  getUserSettings() {
    if (this.userSettings) {
      return /** @type {!angular.$q.Promise<appx.UserSettings>} */ (
        Promise.resolve(this.userSettings)
      );
    }
    if (!this.userSettingsPromise_) {
      this.userSettingsPromise_ = this.configApiService_.getUserSettings();
    }
    return this.userSettingsPromise_;
  }

  /**
   * @param {!appx.UserSettings} userSettings
   * @return {!angular.$q.Promise}
   */
  saveUserSettings(userSettings) {
    return this.configApiService_.putUserSettings(userSettings).then(() => {
      this.userSettings = userSettings;
    });
  }
}

export default angular.module('appConfigStateService', []).service('appConfigStateService', ConfigStateService);
